

export function shuffleArray(arr: Array<any>): Array<any> {
  const copy = arr.slice(0);
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = copy[j];
    copy[j] = copy[i];
    copy[i] = temp;
  }
  return copy;
}

export function chunkArray<T>(arr: T[], size: number = 1000): T[][] {
  if (Array.isArray(arr) === false) {
    return undefined;
  }

  const chunks = Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
    arr.slice(index * size, index * size + size),
  );

  if (chunks.length === 0 || chunks[0].length === 0) {
    return undefined;
  }

  return chunks;
}

